import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth/auth-provider";

/**
 * Lands here after the user clicks the confirmation/magic link in their email.
 * Supabase's client picks up the URL hash automatically (detectSessionInUrl: true);
 * we just bounce to the right place once the session resolves.
 */
export function AuthCallbackPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    void navigate({ to: user ? "/select-tenant" : "/sign-in", replace: true });
  }, [loading, user, navigate]);

  return (
    <main className="flex min-h-dvh items-center justify-center bg-neutral-950 text-sm text-neutral-400">
      Finalizing sign-in…
    </main>
  );
}
